import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';

export type UserGroupDataType = CommonDT & {
  groupType: string;
  groupName: string;
  groupLevel: number;
  groupDesc: string[];
  groupZone: { areaName: string; areaList: string[] };
  periodDays: number;
  originalPrice: number;
  discountPrice: number;
  groupIcon: string;
  groupBgcolor: string;
  pointsThreshold: number;
  cosumeThreshold: number;
  loginDaysThreshold: number;
  clockDaysThreshold: number;
};

export type UserGroupBatchDataType = {
  userGroups: UserGroupDataType[];
};

export type UserGroupPageDataType = {
  pageParams: PageParams;
  filter?: UserGroupDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/usr/userGroup/', id);
};
const getByLevel = async (userGroupLevel: string): Promise<ResultType> => {
  return await _get('/usr/userGroup/getByLevel/', userGroupLevel);
};

const list = async (data?: UserGroupDataType): Promise<ResultType> => {
  return await _post('/usr/userGroup/list', data);
};

const page = async (data?: UserGroupPageDataType): Promise<ResultType> => {
  return await _post('/usr/userGroup/page', data);
};

const batchSave = async (data: UserGroupBatchDataType): Promise<ResultType> => {
  return await _post('/usr/userGroup/batchSave', data);
};

const batchUpdate = async (data: UserGroupBatchDataType): Promise<ResultType> => {
  return await _put('/usr/userGroup/batchUpdate', data);
};

const alterStatus = async (userGroupId: string, status: number): Promise<ResultType> => {
  return await _req('/usr/userGroup/alterStatus', 'PUT', {
    userGroupId,
    status,
  });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/usr/userGroup/batchRemove', ids);
};

const UserGroupApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  getByLevel,
};

export default UserGroupApi;
